/**
 * Recusa de permissao que veio DEPOIS do login ter dado certo: o auth
 * autenticou, mas uma chamada seguinte (setCorp, appmenu...) foi negada.
 *
 * O que separa isto de uma recusa do proprio login e o `errorcode`: toda
 * recusa de login (`responseLoginFail`, que tambem e HTTP 403) traz um, e o
 * 401 "Unauthorized user." e um 403 sem ele nao trazem.
 */
function foiNegadoDepoisDeAutenticar(error) {
    const errorCode = error?.response?.data?.errorcode;
    const status = error?.response?.status ?? error?.status;

    return (errorCode === undefined || errorCode === null) && (status === 401 || status === 403);
}

/**
 * `posLogin` e so da tela de login, onde o `catch` cobre o login e tambem os
 * passos seguintes. As outras telas que chamam esta funcao (troca de senha,
 * perfil) recebem o mesmo 401 "Unauthorized user." do auth por motivos que
 * nada tem a ver com entrar no sistema -- dizer ali que a pessoa "autenticou
 * mas nao tem permissao para acessar este sistema" seria falso.
 */
export async function handleLoginError(error, t, { posLogin = false } = {}) {
    const data = error?.response?.data || {};
    const errorCode = data.errorcode;
    const errorMessage = data.error;

    const errorCodeMap = {
        [-1]: "common.messages.errors.loginProvidedDoesnotExist",
        [-2]: "common.messages.errors.invalidLogin",
        [2]:  "common.messages.errors.twoFactorCodeExpired",
        [1]:  "common.messages.errors.invalidTwoFactorCode",
        [7]:  "common.messages.errors.unableToAccessTheSystemThroughAnUnregisteredIP",
    };

    if (errorCode in errorCodeMap) {
        return t(errorCodeMap[errorCode]);
    }

    const errorMessageMap = {
        "The new password has already been used previously.": "components.myProfile.changePassword.newPasswordAlreadyUsed",
        "Invalid authorization key.": "common.messages.errors.resetLinkExpired",
    };

    if (errorMessage && errorMessageMap[errorMessage]) {
        return t(errorMessageMap[errorMessage]);
    }

    if (posLogin && foiNegadoDepoisDeAutenticar(error)) {
        return t("common.messages.errors.authenticatedWithoutPermission");
    }

    return t("common.messages.errors.generic");
}

export async function handleError(error, t, name = null) {
    switch (error.status) {
        case 400:
            return t("common.messages.errors.400");
        case 401:
        case 403:
            return t("common.messages.errors.403");
        case 409:
            return t("common.messages.errors.409", {name: name});
        default:
            return t("common.messages.errors.generic");
    }
}
